import React from 'react';
import { st, classes } from '../../Widget.st.css';
import AccordionsTwoColumns from './AccordionsTwoColumn';
import AccordionsOneColumn from './AccordionsOneColumn';
import { Structure } from '../../../../../enums';
import { useSettings } from '@wix/tpa-settings/react';
import { ISettingsContextValue } from '@wix/tpa-settings';
import settingsParams from '../../../settingsParams';
import { QuestionEntry } from '@wix/ambassador-faq-question-entry-v2-question-entry/types';
import { AccordionCSS } from './Interfaces';

const AccordionWrapper = ({
  filteredQuestions,
}: {
  filteredQuestions: QuestionEntry[];
}) => {
  const settings: ISettingsContextValue = useSettings();
  const structureColumn: Structure = settings.get(settingsParams.structure);
  const twoColumnStructure: boolean = structureColumn === Structure.TWO_COLUMNS;
  const { gap } = settings.get(settingsParams.spacing);
  const customStyle = {
    '--item-gap': `${gap}px`,
  } as AccordionCSS;

  return (
    <div
      style={customStyle}
      className={st(classes.Body, { isTwoColumn: twoColumnStructure })}
    >
      {twoColumnStructure ? (
        <AccordionsTwoColumns filteredQuestions={filteredQuestions} />
      ) : (
        <AccordionsOneColumn filteredQuestions={filteredQuestions} />
      )}
    </div>
  );
};

export default AccordionWrapper;
